import { render } from "./PageToolbar.vue?vue&type=template&id=bb0aab50&scoped=true"
import script from "./PageToolbar.vue?vue&type=script&lang=js"
export * from "./PageToolbar.vue?vue&type=script&lang=js"

import "./PageToolbar.vue?vue&type=style&index=0&id=bb0aab50&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb0aab50"]])

export default __exports__